import React from "react";
import Newnabar from "../components/shared/Newnabar";
import CommunityGuidelinesWelcome from "../components/community-guidelines/CommunityGuidelinesWelcome";
import Communityguidelinesgrid from "../components/community-guidelines/Communityguidelinesgrid";
import Commitmentandcta from "../components/community-guidelines/Commitmentandcta";
import SoloConnectFooter from "../components/shared/SoloConnectFooter";
import SoloConnectMobileFooter from "../components/shared/SoloConnectMobileFooter";
import SEO from "../seo/SEO";

export default function CommunityGuidelines() {
  return (
    <div className="scroll-smooth bg-slate-50 text-slate-800 font-sans min-h-screen pt-16">
      <SEO
        title="Community Guidelines | SoloConnect"
        description="Read the community guidelines for SoloConnect. Learn how we maintain a safe, respectful, and welcoming environment for all solo travelers."
        keywords="community guidelines, rules, solo travel safety, respectful community, SoloConnect"
      />

      {/* NAVBAR */}
      <Newnabar />

      {/* WELCOME SECTION */}
      <div data-aos="fade-in">
        <CommunityGuidelinesWelcome />
        <Communityguidelinesgrid />
        <Commitmentandcta />
      </div>

      {/* FOOTER */}
      <div className="hidden md:block" data-aos="fade-up">
        <SoloConnectFooter />
      </div>
      <div className="block md:hidden" data-aos="fade-up">
        <SoloConnectMobileFooter />
      </div>
    </div>
  );
}
